import useColumns from './useColumns';

const useEnabledColumns = (userId) => {
    const [columns, isLoadingColumns] = useColumns(userId);
    return [columns.filter((column) => column.enabled), isLoadingColumns];
};

export default useEnabledColumns;
